import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ConfiguracionService, ActividadService, UserAvatarService,
  AuthenticationService, DialogsService, ColaboradoresService, NavigationService, SpinnerService } from '../../services';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ENTITY_TYPE_COLABORADOR } from '../common/activity-list/activity-list.component';
import { MdSnackBar } from '@angular/material';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {

  private colaborador;
  private colaboradorId;
  private actividad = [];

  estadisticasConsignas = 0;
  estadisticasLogros = 0;
  estadisticasPuntos = 0;

  actividadPage: number = 0;
  lastActividadPage: number;


  ENTITY_TYPE_COLABORADOR = ENTITY_TYPE_COLABORADOR;

  avatarSubscription: Subscription;

  userNotif = [];
  consignaNotif = [];

  selectedTabIndex = 0;

  // variables de notificacion
  public hours: number = 1;
  public type: number = 1;  // 1: hours, 24: days, 168: weeks

  public max: number = 24;
  public min: number = 1;

  public neg_hours: number = 1;
  public neg_type: number = 1;  // 1: hours, 24: days, 168: weeks

  public neg_max: number = 24;

  public unsavedNotif = false;
  public unsavedNeg = false;
  public unsavedCons = false;
  public unsavedConsPush = false;


  constructor(private route: ActivatedRoute,
              private colaboradoresService: ColaboradoresService,
              private location: Location,
              private dialogsService: DialogsService,
              private navigationService: NavigationService,
              private authService: AuthenticationService,
              private avatarService: UserAvatarService,
              private actividadService: ActividadService,
              private configService: ConfiguracionService,
              private spinnerService: SpinnerService,
              private snackBar: MdSnackBar) { }

  ngOnInit() {

    this.avatarSubscription = this.avatarService.avatar$.subscribe(
      avatar => {
        if (this.colaborador) {
          this.colaborador.UserAvatarUrl = avatar;
        }
      }
    );

    this.colaboradorId = localStorage.getItem('userId');
    this.loadData();
    this.loadConfigData();
  }

  loadData(){
    this.colaboradoresService.getColaborador(this.colaboradorId)
        .subscribe(value => {
          console.log(value);
          this.colaborador = value;
        });

    this.getActividad();
  }

  loadConfigData() {
    this.configService.getConfiguration().subscribe(r => {
      // primero obtenemos los valores hora sin procesar
      this.hours = r.HoursBeforeNotification > 2688 ? 2688 : r.HoursBeforeNotification;
      // revisamos el tipo haciendo una conversion a la menor unidad posible (ej: 1 semana = 7 dias)
      this.type = this.hours <= 24 ? 1 : (this.hours <= 720 ? 24 : 168);
      // finalmente convertimos las horas a las unidades del slider
      this.hours = this.hours / this.type;
      this.max = this.type === 1 ? 24 : (this.type === 24 ? 30 : 16);

      this.neg_hours = r.HoursBeforeNotificationNegocio > 2688 ? 2688 : r.HoursBeforeNotificationNegocio;
      this.neg_type = this.neg_hours <= 24 ? 1 : (this.neg_hours <= 720 ? 30 : 168);
      this.neg_hours = this.neg_hours / this.neg_type;
      this.neg_max = this.neg_type === 1 ? 24 : (this.neg_type === 24 ? 30 : 16);

      if (r.Notificaciones) {
        const entidades = r.Notificaciones.filter((v, i) => r.Notificaciones.findIndex(x => x.ActividadEntidad.Id === v.ActividadEntidad.Id) === i).map(x => x.ActividadEntidad);
        entidades.forEach(x => x.ActividadAccion = []);
        entidades.forEach(x => {
          r.Notificaciones.filter(y => y.ActividadEntidad.Id === x.Id).forEach(y => {
            x.ActividadAccion.push({
              ActividadAccion: y.ActividadAccion,
              Email: y.Email,
              Push: y.Push,
              Id: y.Not_Con_Id
            });
          });
        });
        // separamos en dos las notificaciones para colocarlas en duferentes componentes
        this.userNotif = entidades.filter(x => x.Nombre !== 'Consigna');
        this.consignaNotif = entidades.filter(x => x.Nombre === 'Consigna');
        console.log(this.userNotif);
      }
      this.setUnsaved(false);
    });
  }

  getActividad() {
    // si se busca la misma pagina dos veces se replican los resultados, no buscar a menos que sean paginas distintas
    // la pagina a buscar cambia al llegar al fondo al hacer scroll, solo entonces refrescar actividades
    if (this.lastActividadPage !== this.actividadPage) {
      this.lastActividadPage = this.actividadPage;

      this.colaboradoresService.getActividad(this.colaboradorId, this.actividadPage)
        .subscribe(value => {

          console.log('response data');
          console.log(value.ResponseData);

          this.actividad = [...this.actividad, ...value.ResponseData.Result];
        });
    }
  }

  showNewConsignaDialog(){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', this.colaborador, null);
  }

  getEstadisticas(){
    this.colaboradoresService.getEstadisticasColaborador(this.colaboradorId)
      .subscribe(data => {
        let { ResponseData } = data;
        this.estadisticasConsignas = ResponseData.ConsignasCantidad;
        this.estadisticasLogros = ResponseData.LogrosPorcentaje;
        this.estadisticasPuntos = ResponseData.Puntos;
      });
  }

  editColaborador(){
    this.dialogsService.showNewColaboradorDialog(
        this.colaborador
      ).subscribe( () => {
          this.loadData();
      });
  }

  toggleNav(){
    this.navigationService.toggleNav(true);
  }

  logout() {
    this.authService.logout();
    this.actividadService.cancelCheckActivities();
  }

  onBottomReached(reached: boolean) {
    this.actividadPage++;
    this.getActividad();
  }

  updateMax(e) {
    this.max = e.value === 1 ? 24 : (e.value === 24 ? 30 : 16);
    this.hours = this.hours > this.max ? this.max : this.hours;
    this.setUnsaved(true, 'cons');
  }

  updateNegMax(e) {
    this.neg_max = e.value === 1 ? 24 : (e.value === 24 ? 30 : 16);
    this.neg_hours = this.neg_hours > this.neg_max ? this.neg_max : this.neg_hours;
    this.setUnsaved(true, 'neg');
  }

  onSubmitConfig(onTabChange = false) {
    // verificamos on tab change porque al cambiar de tab se guardan los cambios realizados
    if (!this.getUnsaved() || (onTabChange && this.selectedTabIndex === 0)) {
      return;
    }
    // construimos el Objeto para enviar al back
    const payload = [];
    this.userNotif.forEach(x => {
      x.ActividadAccion.forEach(y => {
        payload.push({
          ActividadEntidad: {
            Id: x.Id,
            Nombre: x.Nombre
          },
          ActividadAccion: {
            Id: y.ActividadAccion.Id,
            Descripcion: y.ActividadAccion.Descripcion
          },
          Email: y.Email,
          Push: y.Push,
          Not_Con_Id: y.Id
        });
      });
    });
    this.consignaNotif.forEach(x => {
      x.ActividadAccion.forEach(y => {
        payload.push({
          ActividadEntidad: {
            Id: x.Id,
            Nombre: x.Nombre
          },
          ActividadAccion: {
            Id: y.ActividadAccion.Id,
            Descripcion: y.ActividadAccion.Descripcion
          },
          Email: y.Email,
          Push: y.Push,
          Not_Con_Id: y.Id
        });
      });
    });

    this.spinnerService.setShowFlag(true);
    this.configService.setConfiguration(
      String(this.hours * this.type),
      String(this.neg_hours * this.neg_type),
      payload
      )
      .subscribe(() => {
        this.spinnerService.setShowFlag(false);
        this.setUnsaved(false);
        this.snackBar.open('Configuración guardada correctamente', '', {
          duration: 2000,
        });
      }, (err) => {
        this.spinnerService.setShowFlag(false);
        this.snackBar.open('Hubo un inconveniente al guardar la configuracion. Por favor intente nuevamente.', '', {
          duration: 2000,
        });
    });
  }

  setUnsaved(bool: boolean, entity = 'all') {
    switch (entity) {
      case 'all':
        this.unsavedCons = bool;
        this.unsavedNeg = bool;
        this.unsavedNotif = bool;
        this.unsavedConsPush = bool;
        break;
      case 'cons':
        this.unsavedCons = bool;
        break;
      case 'neg':
        this.unsavedNeg = bool;
        break;
      case 'notif':
        this.unsavedNotif = bool;
        break;
      case 'consPush':
        this.unsavedConsPush = bool;
        break;
    }
  }

  getUnsaved() {
    return this.unsavedCons || this.unsavedNotif || this.unsavedNeg || this.unsavedConsPush;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/perfil/perfil.component.ts